import { useEffect, useRef } from "react";
import { useEffectEvent } from "@/shared/hooks/useEffectEvent";
import type { FormValues } from "../form";
import { getHistoryFormValues, isBackForwardNavigation } from "./formHistoryState";

interface UseRestoreFormHistoryStateOptions {
    enabled: boolean;
    /** Accepts a callback because the hook runs above the <Form> tree where useFormAPI() is unavailable. */
    setValues: (values: FormValues) => void;
}

/**
 * Restores form values from history.state on back/forward navigation
 * via setValues (not defaultValues) so the form is marked dirty immediately.
 */
export const useRestoreFormHistoryState = ({ enabled, setValues }: UseRestoreFormHistoryStateOptions): void => {
    const restoredRef = useRef(false);

    const onSetValues = useEffectEvent(setValues);

    useEffect(() => {
        if (restoredRef.current) return;
        if (!enabled) return;
        if (!isBackForwardNavigation()) return;

        const savedValues = getHistoryFormValues();
        if (!savedValues) return;

        restoredRef.current = true;
        onSetValues(savedValues);
    }, [enabled]);
};
